<template>
  <el-dialog
    :modal="true"
    :modal-append-to-body="true"
    :title="title"
    :visible.sync="show"
    :close-on-click-modal="false"
    :show-close="true"
    :close-on-press-escape="true"
    :before-close="clickCancel"
    width="832px" class="courseEditDialog">
    <el-form :model="courseForm" :rules="rules" ref="courseForm">
      <el-form-item label="课程名称" prop="courseName" class="courseName">
        <el-input v-model.trim="courseForm.courseName" autocomplete="off" placeholder="请输入课程名称" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="课程简介" prop="courseIntroduction" class="courseIntroduction">
        <el-input type="textarea" v-model="courseForm.courseIntroduction" placeholder="限150字" maxLength="150"></el-input>
      </el-form-item>
      <div :style="(productFlag==2||productFlag==3||productFlag==4||productFlag==7)?'display:flex':''">
        <div class="subject_classHour">
          <el-form-item label="专业科目" prop="subject" class="subject">
            <el-select v-model="courseForm.subject" placeholder="请选择所属专业科目" v-if="subjectList.length>0" :disabled="isChangeSubject" @change="change">
              <el-option
                v-for="item in subjectList"
                :key="item.id"
                :label="item.name"
                :title="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课时" prop="classHour" class="classHour">
            <el-input v-model="courseForm.classHour" placeholder="请输入课时数" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"/>
          </el-form-item>
        </div>
        <!-- <el-form-item label="封面" prop="coursePic" :style="productFlag==3?'width: 40%':'width: 60%'"> -->
        <div v-if="productFlag==2||productFlag==3||productFlag==4||productFlag==7">
          <el-form-item label="选择岗位" prop="post" class="post">
            <el-select v-model="courseForm.post" multiple placeholder="请选择岗位">
              <el-option
                v-for="item in postList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <el-form-item v-if="productFlag!=7" label="课程类型" prop="isPay" class="subject">
        <el-select v-model="courseForm.isPay" placeholder="请选择">
          <el-option label="标准" :value="1"></el-option>
          <el-option label="免费" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="封面" prop="coursePic" style="width: 60%">
        <el-upload
          class="avatar-uploader"
          :data="uploadData"
          :disabled="isDisabled"
          :action="uploadSrc"
          :headers="headers"
          accept=".jpg,.png,.jpeg"
          :show-file-list="false"
          :on-progress="handleAvatarProgress"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload" v-model="pic">
          <img v-if="pic" :src="pic" class="avatar">
          <i v-else :class="uploadIcon"></i>
        </el-upload>
      </el-form-item>
      <div v-if="productFlag==2||productFlag==3||productFlag==4||productFlag==7" class="tips">
        <p>* 提示：课程创建后不可修改科目和岗位。</p>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="clickCancel">取消</el-button>
      <el-button type="primary" @click="submitForm('courseForm')">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as api from '../../../api/courseApi'
import * as subjectApi from '../../../api/statisticsApi'
import './courseInfoDialog.scss'
  export default {
    props: {
      title: {
        type: String,
        default: '标题'
      },
      courseForm: {
        type: Object,
        default: function(){
          return {
            courseName: '',
            subject:'',
            type: '',
            coursePic: '',
            classHour: '',
            courseIntroduction: '',
            courseProfessional: '',
            courseDetails: '',
            isPay: 1,   // 0免费1付费
            post: []
          }
        }
      },
      imageUrl: {
        type: String,
        default: ''
      },
      showModalconfirm:{
        type:Boolean,
        default:false
      },
      isType: {
        type:Boolean,
        default:true
      }
    },
    data(){
      return {
        show:false,
        pic: '',
        uploadIcon: 'el-icon-plus avatar-uploader-icon',
        subjectList: [],
        rules: {
          courseName: [
            { required: true, message: '请输入课程名称', trigger: 'blur' },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          subject:[
            { required: true, message: '请选择所属科目', trigger: 'change' }
          ],
          coursePic: [
            { required: false, message: '请上传封面', trigger: 'change' }
          ],
          courseProfessional: [
            { required: true, message: '请选择学科分类', trigger: 'change' }
          ],
          post: [
            { required: true, message: '请选择岗位', trigger: 'change' }
          ]
        },
        isDisabled: false,
        isSys:localStorage.getItem('isSys')&&(localStorage.getItem('isSys')==0),
        uploadSrc: `${process.env.UPLOAD_NAME}/file/uploadImage`,
        isChangeSubject: false,
        productFlag: sessionStorage.getItem('productFlag'),
        postList: [],//岗位列表
      }
    },
    computed: {
      uploadData(){
        return {
          "savepath":"cjdd/course/logo"
        }
      },
      headers(){
        return {
          "Authorization": "bearer "+localStorage.getItem('Authorization')
        }
      }
    },
    created() {
      if(this.title == '编辑课程'){
        this.isChangeSubject = true
      }else{
        this.isChangeSubject = false
      }
    },
    methods: {
      //上传图片
      handleAvatarSuccess(res, file) {
        let that = this
        this.pic = URL.createObjectURL(file.raw);
        this.courseForm.coursePic = res.data.imagePath
        this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
        this.$refs['courseForm'].validateField('coursePic', val => {
          if (!val) {
            that.rules.coursePic[0].message='请上传封面'
            that.isDisabled = false
          }
        })
      },
      handleAvatarProgress(){
        let that = this
        this.pic = '';
        this.courseForm.coursePic = ''
        this.uploadIcon = 'el-icon-loading avatar-uploader-icon'
        this.$refs['courseForm'].validateField('coursePic',(val,callback)=>{
          that.rules.coursePic[0].message='上传中，请稍后'
          that.isDisabled = true
        })
      },
      beforeAvatarUpload(file) {
        this.uploadIcon = 'el-icon-loading avatar-uploader-icon'
        let jpg = file.type === 'image/jpeg'||file.type === 'image/jpg'
        let png = file.type === 'image/png'
        const isJPG = jpg||png;
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
          this.$message.error('上传封面图片仅限 JPG 和 PNG 格式!');
          this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
        }
        if (!isLt10M) {
          this.$message.error('上传封面图片大小不能超过 10MB!');
          this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
        }
        return isJPG && isLt10M;
      },
      clickCancel(){
        this.show = false
        this.$emit('onclickCancel')
        this.pic = '';
        this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
        this.isDisabled = false
        this.resetForm('courseForm')
      },
      // 提交添加、修改的课程
      submitForm(formName) {
        console.log(formName);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.uploadIcon=='el-icon-loading avatar-uploader-icon'){
              this.$messageWarning('上传中，请稍后')
            }else{
              this.$emit('courseInfoUrl',formName);
              // this.resetForm(formName)
            }
          }else{
            console.log('error')
            return false
          }
        })
      },
      // 重置表单
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.courseForm.courseDetails = ''
        this.pic = this.imageUrl;
      },
      //获取科目列表
      getSubjectList(id){
        let that = this
        api.getSubjectData().then((rs)=>{
          if(rs.code==0){
            that.subjectList = []
            let obj = {}
            rs.data.forEach((item,i)=>{
              if(item.professionId == id){
                obj = {
                  id: item.id,
                  name: item.name,
                  professionId: item.professionId
                }
                that.subjectList.push(obj)
              }
            })
          }else{
            this.$messageError(rs.msg)
          }
        }).catch((error)=>{
          console.log(error)
        })
      },
      selectProfessional(val){
        // this.courseForm.subject = ''
        // this.getSubjectList(val)
      },
      change(val){
        subjectApi.FindStationBySubjectId(val).then(rs=>{
          if(rs.code==0){
            this.postList = rs.data
            this.courseForm.post = []
          }else{
            this.$messageError(rs.msg)
          }
        })
      }
    },
    watch:{
      showModalconfirm(val){
        this.show = val
        if(val){
          this.getSubjectList(sessionStorage.getItem('professional'))
        }
      },
      imageUrl(val){
        this.pic = val
      }
    }

  }
</script>




// WEBPACK FOOTER //
// src/components/dialog/course/courseInfoDialog.vue